import React, {useCallback, useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {ClientListRepository} from "../../repository/AdminDashboard/Client-Repository";
import toast from "react-hot-toast";
import {AdminListRepository} from "../../repository/AdminDashboard/Admin-Repository";
import useListContext from "../../tools/useListContext";
import {useModal} from "../../tools/useModal";

const adminContext = React.createContext();

export function AdminContextProvider({children}) {
    const {
        handleUpdateListState,
        listState,
        onDevicePerPageChange,
        changePage,
        onSearchBtnClick,
    } = useListContext(getAdmins)
    const {closeModal, openModal, modalState} = useModal();

    async function getAdmins() {

        handleUpdateListState("loading", true)
        const response = await AdminListRepository.getAdminList(listState.searchQuery, listState.pageNumber)
        handleUpdateListState("loading", false)

        if (response.code !== 1) {
            toast.error(response.massage, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }

        handleUpdateListState("list", response.adminClassList)
        handleUpdateListState("countAll", response.countAllPages)
    }


    async function onAcceptDeleteAdminClick() {
        const response = await AdminListRepository.deleteAdmin(modalState.selectedItem.id);
        if (response.code !== 1) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        closeModal()
        await getAdmins();
    }

    async function addUpdateAdmin(data) {
        data.number = "+98" + data.number.trim().slice(1);
        const response = await AdminListRepository.editAddAdmin(data);
        if (response.code !== 1) {
            console.log("Add Client Error")
            return;
        }
        await getAdmins();
    }

    function openDeleteModal(item) {
        openModal("delete", item)
    }

    function openAddEditModal(item) {
        openModal(item == null ? "add" : "edit", item)

    }

    return (
        <adminContext.Provider value={{
            onSearchBtnClick,
            changePage,
            onDevicePerPageChange,
            onAcceptDeleteAdminClick,
            addUpdateAdmin,
            listState,
            handleUpdateListState,
            closeModal,
            openDeleteModal,
            openAddEditModal,
            modalState
        }}>
            {children}
        </adminContext.Provider>
    )
}


export default function useAdminContext() {
    return React.useContext(adminContext)
}

